<template>
  <div>
    <h2>Wyniki</h2>
    <hr />
    <div id="wyniki">
      <ul>
        <li>
          Wódka:
          <b>{{resultIleButelekWodki}} butelek</b>
          <a
            v-if="resultIleButelekWodki && !selectedVodka()"
            href
            @click.prevent="showItems('vodka', resultIleButelekWodki)"
          >dobierz</a>
          <b v-else-if="resultIleButelekWodki" :alt="redrawTrigger">
            {{selectedVodka().name}} {{$n(selectedVodka().price, 'currency')}} x {{selectedVodka().qty}} =
            <i>{{$n(cart.getTotalPriceByType('vodka'), 'currency')}}</i>
            <a href @click.prevent="showItems('vodka', resultIleButelekWodki)">zmień</a>
          </b>
        </li>

        <li>
          Wino białe:
          <b>{{resultIleButelekWinaWhite}} butelek</b>
          <a
            v-if="resultIleButelekWinaWhite && !selectedWineWhite()"
            href
            @click.prevent="showItems('wineWhite', resultIleButelekWinaWhite)"
          >dobierz</a>
          <b v-else-if="resultIleButelekWinaWhite" :alt="redrawTrigger">
            {{selectedWineWhite().name}} {{$n(selectedWineWhite().price, 'currency')}} x {{selectedWineWhite().qty}} =
            <i>{{$n(cart.getTotalPriceByType('wineWhite'), 'currency')}}</i>
            <a href @click.prevent="showItems('wineWhite', resultIleButelekWinaWhite)">zmień</a>
          </b>
        </li>

        <li>
          Wino czerwone:
          <b>{{resultIleButelekWinaRed}} butelek</b>
          <a
            v-if="resultIleButelekWinaRed && !selectedWineRed()"
            href
            @click.prevent="showItems('wineRed', resultIleButelekWinaRed)"
          >dobierz</a>
          <b v-else-if="resultIleButelekWinaRed" :alt="redrawTrigger">
            {{selectedWineRed().name}} {{$n(selectedWineRed().price, 'currency')}} x {{selectedWineRed().qty}} =
            <i>{{$n(cart.getTotalPriceByType('wineRed'), 'currency')}}</i>
            <a href @click.prevent="showItems('wineRed', resultIleButelekWinaRed)">zmień</a>
          </b>
        </li>

        <li>
          Wino musujące:
          <b>{{resultIleButelekWinaMus}} butelek</b>
          <a
            v-if="resultIleButelekWinaMus && !selectedWineMus()"
            href
            @click.prevent="showItems('wineSpark', resultIleButelekWinaMus)"
          >dobierz</a>
          <b v-else-if="resultIleButelekWinaMus" :alt="redrawTrigger">
            {{selectedWineMus().name}} {{$n(selectedWineMus().price, 'currency')}} x {{selectedWineMus().qty}} =
            <i>{{$n(cart.getTotalPriceByType('wineSpark'), 'currency')}}</i>
            <a href @click.prevent="showItems('wineSpark', resultIleButelekWinaMus)">zmień</a>
          </b>
        </li>

        <li>
          Wino deserowe:
          <b>{{resultIleButelekWinaDeser}} butelek</b>
          <a
            v-if="resultIleButelekWinaDeser && !selectedWineDeser()"
            href
            @click.prevent="showItems('wineDeser', resultIleButelekWinaDeser)"
          >dobierz</a>
          <b v-else-if="resultIleButelekWinaDeser" :alt="redrawTrigger">
            {{selectedWineDeser().name}} {{$n(selectedWineDeser().price, 'currency')}} x {{selectedWineDeser().qty}} =
            <i>{{$n(cart.getTotalPriceByType('wineDeser'), 'currency')}}</i>
            <a href @click.prevent="showItems('wineDeser', resultIleButelekWinaDeser)">zmień</a>
          </b>
        </li>
        <li>
          Wino bezalkoholowe:
          <b>{{resultIleButelekWinaBezAlko}} butelek</b>
          <a
            v-if="resultIleButelekWinaBezAlko && !selectedWineEco()"
            href
            @click.prevent="showItems('wineEco', resultIleButelekWinaBezAlko)"
          >dobierz</a>
          <b v-else-if="resultIleButelekWinaBezAlko" :alt="redrawTrigger">
            {{selectedWineEco().name}} {{$n(selectedWineEco().price, 'currency')}} x {{selectedWineEco().qty}} =
            <i>{{$n(cart.getTotalPriceByType('wineEco'), 'currency')}}</i>
            <a href @click.prevent="showItems('wineEco', resultIleButelekWinaBezAlko)">zmień</a>
          </b>
        </li>
      </ul>
    </div>
    <h2>Całkowita wartość zamówienia:</h2>
    <div id="suma">
      <i>{{$n(cart.totalPrice, 'currency')}}</i>
      <br />Pobierz pdf
      <form id="formDownload" name="formDownload" method="get" action="/document/pdf">
        <input type="hidden" name="id" />
      </form>
      <br />
      <img
        src="../assets/img/ikonkapdf.png"
        alt="ikonkapdf"
        style="cursor: pointer"
        @click="registerDoc"
        v-show="!docCreateInProgress"
      />
      <span v-if="docCreateInProgress">czekaj...</span>
      <br />
      <br />Jeżeli nie masz pytań złóż zamówienie
      <br />

      <img
        src="../assets/img/zlozzam.png"
        alt="ikonkapdf"
        @click="showFinalizeQuotationOverlay=true"
        style="cursor: pointer"
      />
      <br />
      <br />Masz więcej pytań?
      <a href="mailto:seo@findable.pl">skontaktuj się z nami</a>
    </div>
    <div id="kalkinne">
      <h2>Czy chcesz dobrać wino do menu weselnego?</h2>
      <hr />
      <br />Napisz nam swoje menu lub załącz plik i wyślij na adres
      <a href="mailto:#">wesle@dobrewino.pl</a> a my prześlemy Ci nasze rekomendacje.
      <h2>Czy szukasz ciekawych upominków dla gości?</h2>
      <hr />
      <br />Sprawdź nasze pomysły, jak obdarować twoich gości weselnych
      <br />
      <a href="#">
        <img src="../assets/img/prezentyw.png" />
      </a>
      <br />
      <h2>Chcesz podarować rodzicom piękny kosz prezentowy?</h2>
      <hr />
      <br />Zobacz nasze propozycje prezentowe
      <br />
      <a href="#">
        <img src="../assets/img/prezentyw.png" />
      </a>
      <br />
      <h2>Podróż poślubna do winnicy?</h2>
      <hr />
      <br />Szukasz oryginalnego pomysłu na romantyczny wyjazd? Współpracujemy z winnicami z całego świata ...
      <br />
      <a href="#">
        <img src="../assets/img/prezentyw2.png" />
      </a>
      <br />
      <h2>Zestawy weselne</h2>
      <hr />
      <br />Zoabcz nasze zestawy weselne i skorzystaj nawet z 35% rabatu ...
      <br />
      <a href="#">
        <img src="../assets/img/prezentyw3.png" />
      </a>
      <br />
    </div>
    <div v-if="itemsType" id="tileOverlay">
      <div id="bclose">
        <button @click="itemsType=null">X</button>
      </div>
      <h2>Dobierz: {{$t('itemsType.'+itemsType)}} x {{itemsQty}}</h2>

      <section id="inneprod">
        <div v-for="item in items" :key="item.id">
          <span class="kfoto">
            <img
              v-if="item.img"
              v-bind:src="env.VUE_APP_thumbnailUrl + item.id + '/'+item.img"
              alt="prod1"
            />
            <img v-else src="../assets/img/woda1.png" alt="prod1" />
          </span>
          <span class="knazwa">{{item.name}}</span>
          <span class="kkoszyk">
            <!-- {{$n(item.price * itemsQty, 'currency')}} -->
            <a>{{$n(item.price , 'currency')}}</a>
          </span>
          <span id="zobwyb">
            <a href @click.prevent="viewItem(item.id); selectedItemPrice=item.price">zobacz</a>&nbsp;|&nbsp;
            <a
              href
              @click.prevent="cart.addItem(item, itemsQty); itemsType=null"
            >wybierz</a>
          </span>
        </div>
      </section>
    </div>
    <div id="itemDetailsOverlay" v-if="itemsType && selectedItem">
      <div id="bclose2">
        <a href @click.prevent="selectedItem=null">X</a>
      </div>
      <h1>{{selectedItem.name}}</h1>
      <hr />
      <br />
      {{$n(selectedItemPrice, 'currency')}}
      <br />
      <div id="zdjecie">
        <img
          v-if="selectedItem.imgs && selectedItem.imgs.length"
          v-bind:src="selectedItem.imgs && selectedItem.imgs.length ? env.VUE_APP_imageUrl + selectedItem.id + '/'+ selectedItem.imgs.slice(0,1) : null"
          alt="zdjęcie produktu"
        />
      </div>
      <div id="cechyprod">
        <span id="cena">
          <span>Cena zależy od wielkości zamówienia:</span>
          <br />
          <b>
            do {{selectedItem.cf['cena_hurt1 (cena DW - 7%)'].split(':')[0]}}szt:
            <br />
            <i>{{ $n(selectedItem.cf['cena_hurt1 (cena DW - 7%)'].split(':')[1], 'currency') }}</i>
            <br />
          </b>
          <b>
            do {{selectedItem.cf['cena_hurt2 (cena DW - 10%)'].split(':')[0]}}szt:
            <br />
            <i>{{ $n(selectedItem.cf['cena_hurt2 (cena DW - 10%)'].split(':')[1], 'currency')}}</i>
            <br />
          </b>
          <b>
            do {{selectedItem.cf['cena_hurt3 (cena DW - 15%)'].split(':')[0]}}szt:
            <br />
            <i>{{ $n(selectedItem.cf['cena_hurt3 (cena DW - 15%)'].split(':')[1], 'currency') }}</i>
            <br />
          </b>
          <b>
            powyżej {{selectedItem.cf['cena_hurt3 (cena DW - 15%)'].split(':')[0]}}szt:
            <br />
            <i>{{ $n(selectedItem.cf['cena_hurt4 (cena DW - 20%)'], 'currency') }}</i>
            <br />
          </b>
        </span>

        <span id="cechyfiltr">
          <template v-for="cp in selectedItem.cp">
            <b :key="'b_'+cp.id">{{cp.cName.toUpperCase()}}</b>
            {{cp.name}}
            <br :key="cp.id" />
          </template>
        </span>
      </div>

      <section id="opis" v-html="selectedItem.descr"></section>
    </div>
    <div
      id="finalizeQuotationOverlay"
      v-if="showFinalizeQuotationOverlay"
      style="z-index: 199;position: fixed; top:100px; border: black 3px solid; padding:30px; background:white"
    >
      <div>
        <button
          @click="showFinalizeQuotationOverlay = !showFinalizeQuotationOverlay;quotationResult=null"
        >X</button>
      </div>
      <div>
        <p>Znaleźliście produkty, których szukacie i chcecie je zamówić?</p>
        <p>Wpiszcie swoje dane kontaktowe i kliknij wyślij. Skontakujemy się z wami po otrzymaniu wiadomości</p>
        <form>
          <label
            for="quotationName"
            v-bind:class="{ invalid: !isQuotationFormNameValid() }"
          >Imię i Nazwisko</label>
          <input name="quotationName" id="quotationName" v-model.trim="quotation.name" />
          <br />

          <label
            for="quotationPhone"
            v-bind:class="{ invalid: !isQuotationFormPhoneValid() }"
          >Numer telefonu</label>
          <input name="quotationPhone" v-model.trim="quotation.phone" />

          <br />
          <label for="quotationEmail" v-bind:class="{ invalid: !isQuotationFormEmailValid() }">Email</label>
          <input name="quotationEmail" v-model.trim="quotation.email" />

          <br />
          <p
            v-if="quotationButtonClicked && !isQuotationFormValid()"
          >Uzupełnij formularz przed wysłaniem.</p>
          <img
            v-if="!quotationInProgress && !quotationResult"
            src="../assets/img/zlozzam.png"
            alt="ikonkapdf"
            style="cursor: pointer"
            @click="submitQuotation()"
          />
        </form>
      </div>

      <div v-if="quotationResult">
        <h1>Gotowe</h1>
        <p>Dziękujemy za złożenie zapytania. Niezwłocznie skontakujemy się z Tobą celem przedyskutowania...</p>
        <p>Na email <b>{{quotationResult.quotation.email}}</b> wysłaliśmy potwierdzenie.</p>
        <p>Numer zapytania: {{quotationResult.quotationNumber}}</p>
      </div>
      <div v-if="quotationInProgress">
        <h1>czekaj...</h1>
      </div>
    </div>
  </div>
</template>

<script>
import Cart from "@/cart";
import axios from "axios";
import _ from "lodash";
import firebaseApp from "@/firebase/init";

export default {
  name: "CalcResult",
  props: {
    cart: Cart,
    resultIleButelekWodki: Number,
    resultIleButelekWinaRed: Number,
    resultIleButelekWinaWhite: Number,
    resultIleButelekWinaMus: Number,
    resultIleButelekWinaDeser: Number,
    resultIleButelekWinaBezAlko: Number
  },
  data() {
    return {
      env: process.env,
      itemsType: null,
      itemsQty: 0,
      items: [],
      redrawTrigger: null,
      documentId: null,
      docCreateInProgress: false,
      selectedItem: null,
      selectedItemPrice: null,
      showFinalizeQuotationOverlay: false,
      quotation: {},
      quotationInProgress: false,
      quotationResult: null,
      quotationButtonClicked: false,
      quotationFeedback: null
    };
  },

  computed: {},

  watch: {
    resultIleButelekWodki: _.debounce(function(newVal) {
      this.cart.setQuantity("vodka", newVal);
      this.updatePriceInBasket("vodka", newVal);
    }, 500),
    resultIleButelekWinaRed: _.debounce(function(newVal) {
      this.cart.setQuantity("wineRed", newVal);
      this.updatePriceInBasket("wineRed", newVal);
    }, 500),
    resultIleButelekWinaWhite: _.debounce(function(newVal) {
      this.cart.setQuantity("wineWhite", newVal);
      this.updatePriceInBasket("wineWhite", newVal);
    }, 500),
    resultIleButelekWinaMus: _.debounce(function(newVal) {
      this.cart.setQuantity("wineSpark", newVal);
      this.updatePriceInBasket("wineSpark", newVal);
    }, 500),
    resultIleButelekWinaDeser: _.debounce(function(newVal) {
      this.cart.setQuantity("wineDeser", newVal);
      this.updatePriceInBasket("wineDeser", newVal);
    }, 500),
    resultIleButelekWinaBezAlko: _.debounce(function(newVal) {
      this.cart.setQuantity("wineEco", newVal);
      this.updatePriceInBasket("wineEco", newVal);
    }, 500)
  },

  methods: {
    showItems: function(itemType, qty) {
      console.log("wt " + itemType);
      this.itemsType = itemType;
      this.itemsQty = qty;
      this.items = [];
      var searchq = null;
      if (itemType === "vodka") searchq = "a2";
      else if (itemType === "wineRed") searchq = "a1_c2_d2";
      else if (itemType === "wineWhite") searchq = "a1_c2_d1";
      else if (itemType === "wineSpark") searchq = "a1_c1";
      else if (itemType === "wineDeser") searchq = "a1_e4";
      else if (itemType === "wineEco") searchq = "c5";

      axios
        .get(process.env.VUE_APP_API + "/ui/search.json", {
          params: { q: searchq, qty: qty }
        })

        .then(response => {
          // this.items = response.data.items;
          response.data.items.forEach(item => {
            var simplifiedItem = {
              id: item.id,
              name: item.name,
              type: itemType,
              price: item.price,
              img: item.thumbnail
            };
            // console.log(simplifiedItem);
            this.items.push(simplifiedItem);
          });
        });
    },

    selectedVodka: function() {
      return this.cart.getByType("vodka");
    },
    selectedWineRed: function() {
      return this.cart.getByType("wineRed");
    },
    selectedWineWhite: function() {
      return this.cart.getByType("wineWhite");
    },
    selectedWineMus: function() {
      return this.cart.getByType("wineSpark");
    },
    selectedWineDeser: function() {
      return this.cart.getByType("wineDeser");
    },
    selectedWineEco: function() {
      return this.cart.getByType("wineEco");
    },

    updatePriceInBasket: function(type, qty) {
      // console.log(`updatePriceInBasket ${type} ${qty}`);

      var item = this.cart.getByType(type);
      if (!item) return;

      axios
        .get(process.env.VUE_APP_API + "/ui/item.json", {
          params: { id: item.id, qty: qty }
        })
        .then(response => {
          var newPrice = response.data.item.price;
          console.log(`newPrice ${qty} ${type} ${item.id}: ${newPrice}`);

          this.cart.setPrice(type, newPrice);
          this.redrawTrigger = Math.random();
        })
        .finally(function() {});
    },

    registerDoc: function() {
      console.log("r d");
      this.docCreateInProgress = true;
      var docCreate = firebaseApp.functions().httpsCallable("docCreate");
      docCreate({
        template: "calculator",
        totalOrder: this.$n(this.cart.totalPrice, "currency"),
        vodka: {
          s: this.selectedVodka()
            ? this.buildItem(
                this.selectedVodka(),
                this.cart.getTotalPriceByType("vodka")
              )
            : null
        },
        wineWhite: {
          s: this.selectedWineWhite()
            ? this.buildItem(
                this.selectedWineWhite(),
                this.cart.getTotalPriceByType("wineWhite")
              )
            : null
        },
        wineRed: {
          s: this.selectedWineRed()
            ? this.buildItem(
                this.selectedWineRed(),
                this.cart.getTotalPriceByType("wineRed")
              )
            : null
        },
        wineSpark: {
          s: this.selectedWineMus()
            ? this.buildItem(
                this.selectedWineMus(),
                this.cart.getTotalPriceByType("wineSpark")
              )
            : null
        },
        wineDeser: {
          s: this.selectedWineDeser()
            ? this.buildItem(
                this.selectedWineDeser(),
                this.cart.getTotalPriceByType("wineDeser")
              )
            : null
        },
        wineEco: {
          s: this.selectedWineEco()
            ? this.buildItem(
                this.selectedWineEco(),
                this.cart.getTotalPriceByType("wineEco")
              )
            : null
        }
      })
        .then(result => {
          console.log("docId: " + result.data);
          this.documentId = result.data;
          // this.documentId = "fBc15Alc2xpC7cSWvisX";

          // document.forms["formDownload"].action =
          //   "/document/pdf?id=" + result.data;
          document.forms["formDownload"].elements["id"].value = result.data;
          document.forms["formDownload"].submit();

          setTimeout(() => {
            this.docCreateInProgress = false;
          }, 5555);
        })
        .catch(error => {
          console.log("ERROR " + error);
        });
    },

    buildItem: function(item, totalPrice) {
      return {
        name: item.name,
        price: this.$n(item.price, "currency"),
        qty: item.qty,
        totalPrice: this.$n(totalPrice, "currency")
      };
    },

    viewItem(id) {
      axios
        .get(process.env.VUE_APP_API + "/ui/item.json", {
          params: { id: id }
        })
        .then(response => {
          this.selectedItem = response.data.item;
        });
    },

    isQuotationFormValid: function() {
      return (
        this.isQuotationFormNameValid() &&
        this.isQuotationFormPhoneValid() &&
        this.isQuotationFormEmailValid()
      );
    },

    isQuotationFormNameValid: function() {
      if (!this.quotationButtonClicked) return true;
      return (
        this.quotationButtonClicked &&
        this.quotation.name != null &&
        this.quotation.name != ""
      );
    },

    isQuotationFormPhoneValid: function() {
      if (!this.quotationButtonClicked) return true;
      return (
        this.quotationButtonClicked &&
        this.quotation.phone != null &&
        this.quotation.phone != ""
      );
    },

    isQuotationFormEmailValid: function() {
      if (!this.quotationButtonClicked) return true;
      return (
        this.quotationButtonClicked &&
        this.quotation.email != null &&
        this.quotation.email != ""
      );
    },

    submitQuotation: function() {
      this.quotationButtonClicked = true;

      if (!this.isQuotationFormValid()) return;

      console.log("submitting quotation...");
      this.quotationInProgress = true;

      var quotationCallable = firebaseApp.functions().httpsCallable("qCreate");
      quotationCallable({
        quotation: this.quotation,
        items: Array.from(this.cart.cartItems)
      })
        .then(result => {
          console.log("docId:", result.data);
          this.quotationResult = result.data;
        })
        .catch(error => {
          console.log("ERROR " + error);
        })
        .finally(() => {
          this.quotationInProgress = false;
        });
    }
  }
};
</script>

<style scoped>
#tileOverlay {
  border: 1px solid black;
  position: fixed; /* Sit on top of the page content */
  width: 75%; /* Full width (cover the whole page) */
  min-height: 70%; /* Full height (cover the whole page) */
  height: 300px;
  top: 10%;
  left: 12.5%;
  background-color: white; /* Black background with opacity */
  z-index: 9; /* Specify a stack order in case you're using a different order for other elements */
  padding: 20px;
  color: lightgray;
  overflow: auto;
}
div#bclose,
div#bclose2 {
  position: relative;
  margin-right: 40px;
  text-align: right;
}
#tileOverlay button {
  background: white;
  position: fixed;
  margin-top: 0px;
  border: 2px solid black;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  color: black;
  text-decoration: none;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
}
#inneprod div {
  width: 19%;
  margin: 0.5%;
  float: left;
  outline: 1px solid #aeaeae;
}

#inneprod div:hover {
  box-shadow: 2px 2px 5px 5px;
}

.kfoto {
  text-align: center;
}

.kfoto img {
  width: 100%;
  margin: 10px auto;
}

.knazwa {
  height: 70px;
  font: normal bold 14px/17px "Times New Roman", Times, serif;
  margin: 0px;
  align-items: center;
  letter-spacing: 4px;
  text-transform: uppercase;
}

.kcechy {
  height: 50px;
  font: normal normal 12px/18px "Lato";
  color: black;
  border-top: 1px solid #c4c4c4;
}

.kkoszyk a,
.kkoszyk a:hover {
  width: 114px;
  display: block;
  margin: 10px auto;
  color: #b2172e;
  font: normal 300 18px/28px "Lato";
  text-align: center;
  font-weight: bold;
}
span#zobwyb {
  display: block;
  text-align: center;
}
#zobwyb a {
  display: inline-block;
  outline: 1px solid gray;
  width: 60px;
  font-size: 12px;
  line-height: 28px;
  color: gray;
  font-weight: normal;
  vertical-align: middle;
  text-align: center;
}
#itemDetailsOverlay {
  border: 1px solid black;
  position: fixed;
  z-index: 100;
  width: 99%;
  max-width: 750px;
  background: white;
  height: 300px;
  min-height: 70%; /* Full height (cover the whole page) */
  padding: 20px;
  margin: 0px auto;
  overflow: auto;
}
#itemDetailsOverlay div#bclose2 a {
  background: white;
  position: fixed;
  margin-top: 0px;
  border: 2px solid black;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  color: black;
  text-decoration: none;
  font-size: 16px;
  line-height: 40px;
  font-weight: bolder;
  text-align: center;
}

#zdjecie {
  width: 45%;
  float: right;
  text-align: center;
}
#cechyprod {
  float: right;
  width: 52%;
}

#cechyprod a,
#cechyprod a:hover {
  text-decoration: none;
  color: #141414;
}
#cechyprod a:hover {
  color: #a12332;
}

#zdjecie img {
  width: 100%;
  margin-bottom: 20px;
}

#cena {
  display: block;
  line-height: 30px;
  font-size: 18px;
  font-family: "Lato", sans-serif;
  margin-top: 20px;
  color: black;
  float: left;
  width: 100%;
  margin-bottom: 20px;
}
#cena span {
  font: italic bold 18px/1 "Times New Roman", serif;
  display: block;
}

#cena b {
  font-size: 12px;
  margin-right: 2.5%;
  color: white;
  background: #b2172e;
  display: block;
  text-align: center;
  float: left;
  width: 22%;
  padding: 5px 0px;
}
#cena i {
  font-size: 18px;
  font-style: normal;
}

a#dokoszyka,
a#dokoszyka:hover {
  margin: 25px auto;
  float: left;
  text-align: center;
  font-size: 20px;
  line-height: 60px;
  width: 60%;
  display: block;
  height: 60px;
  background: #a12332;
  color: white;
  border-radius: 50px;
}

#cechyfiltr {
  display: block;
  clear: both;
  font-size: 14px;
}

#cechyfiltr b {
  display: inline-block;
  text-align: left;
  margin-right: 10px;
  height: 20px;
  width: 110px;
  margin-top: 5px;
  text-transform: lowercase;
}
#cechyfiltr b::first-letter {
  text-transform: uppercase;
}

#opis {
  clear: both;
  font-size: 16px;
  line-height: 24px;
}
@media screen and (max-width: 320px) {
  #inneprod div {
    width: 98%;
    margin: 2% 1%;
  }
  .knazwa {
    font-size: 14px;
    height: 70px;
  }
  #tileOverlay {
    width: 90%; /* Full width (cover the whole page) */
    min-height: 99%; /* Full height (cover the whole page) */
    top: 2%;
    left: 2%;
    padding: 10px;
  }
  #itemDetailsOverlay {
    width: 90%;
    min-height: 99%;
    top: 0.3%;
    left: 0.3%;
  }
  #zdjecie {
    width: 90%;
    margin: 0 10%;
  }
  #cechyprod {
    width: 100%;
  }
  #dokoszyka {
    width: 80%;
    margin: 5% 10%;
  }

  #cena b {
    width: 48%;
    margin: 1%;
  }
}

@media screen and (min-width: 321px) and (max-width: 460px) {
  #inneprod div {
    width: 98%;
    margin: 1% 2%;
  }
  .knazwa {
    font-size: 14px;
    height: 70px;
  }
  #tileOverlay {
    width: 90%; /* Full width (cover the whole page) */
    min-height: 98%; /* Full height (cover the whole page) */
    top: 2%;
    left: 2%;
    padding: 10px;
  }
  #itemDetailsOverlay {
    width: 90%;
    min-height: 99%;
    top: 0.3%;
    left: 0.3%;
  }
  #zdjecie {
    width: 100%;
  }
  #cechyprod {
    width: 100%;
  }
  #cena {
    line-height: 20px;
    font-size: 22px;
    margin-top: 10px;
  }
  #dokoszyka {
    width: 80%;
    margin: 5% 10%;
  }
  #cena b {
    width: 48%;
    margin: 1%;
  }
}

@media screen and (min-width: 461px) and (max-width: 600px) {
  #inneprod div {
    width: 48%;
    margin: 1%;
  }
  .knazwa {
    font-size: 14px;
    height: 70px;
  }
  #tileOverlay {
    width: 93%; /* Full width (cover the whole page) */
    min-height: 95%; /* Full height (cover the whole page) */
    top: 1%;
    left: 1.5%;
    padding: 10px;
  }
  #itemDetailsOverlay {
    width: 90%;
    min-height: 99%;
    top: 0.3%;
    left: 0.3%;
  }
  #zdjecie {
    width: 100%;
  }
  #cechyprod {
    width: 100%;
  }
  #dokoszyka {
    width: 80%;
    margin: 5% 10%;
  }
  #cena b {
    width: 23%;
    margin: 1%;
  }
}

@media screen and (min-width: 601px) and (max-width: 750px) {
  #inneprod div {
    width: 48%;
    margin: 1%;
  }
  .knazwa {
    font-size: 14px;
    height: 70px;
  }
  #tileOverlay {
    width: 94%; /* Full width (cover the whole page) */
    min-height: 97%; /* Full height (cover the whole page) */
    top: 1%;
    left: 1%;
    padding: 10px;
  }
  #itemDetailsOverlay {
    width: 94%;
    min-height: 99%;
    top: 0.3%;
    left: 0.3%;
  }
  #zdjecie {
    width: 100%;
  }
  #cechyprod {
    width: 100%;
  }
  #dokoszyka {
    width: 80%;
    margin: 5% 10%;
  }
  #cena b {
    width: 23%;
    margin: 1%;
  }
}
@media screen and (min-width: 751px) {
  #itemDetailsOverlay {
    top: 5%;
    left: 50%;
    transform: translateX(-50%);
  }
}
@media screen and (min-width: 751px) and (max-width: 980px) {
  #tileOverlay {
    width: 85%; /* Full width (cover the whole page) */
    min-height: 85%; /* Full height (cover the whole page) */
    top: 5%;
    left: 6.5%;
    padding: 10px;
  }
  #inneprod div {
    width: 32%;
    margin: 0.5%;
  }
  .knazwa {
    font-size: 14px;
    height: 70px;
  }
}

@media screen and (min-width: 981px) and (max-width: 1280px) {
  #inneprod div {
    width: 24%;
    margin: 0.5%;
  }
}

.invalid {
  color: #a12332;
}
</style>
